import { useTranslation } from "react-i18next";
import { Icon, Label, Popup } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { formatDate } from "utils/dateHelperFunctions";

import type { NoteProps } from "modules/Dayplanner/components/AppointmentCard/components/NotificationIcons";

export const MainNote = ({ note: mainNote }: NoteProps) => {
  const { t } = useTranslation();

  return (
    <Popup
      wide
      basic
      content={
        <div className="AppointmentNotePopup">
          <div className="AppointmentNoteTitle">
            <Icon className="note sticky red" color="red" />
            <span>{t("v8_main_note", "Main Note")}</span>
          </div>
          <div className="AppointmentNoteDescription">
            {mainNote.updated_by
              ? `${mainNote.updated_by.first_name} ${mainNote.updated_by.last_name} ${t("v8_updated_main_note", "updated Main Note")} `
              : `${mainNote.created_by?.first_name} ${mainNote.created_by?.last_name} ${t("v8_added_main_note", "added Main Note")} `}
            {`${formatDate(mainNote.updated_on, DATE_FORMATS_FNS.dateMonthYearTime)}`}
          </div>
          <div className="AppointmentNoteContent">{mainNote.note}</div>
        </div>
      }
      trigger={
        <Label circular color="red">
          <Icon className="note sticky white icon-vertical-align" />
        </Label>
      }
    />
  );
};
